import React from "react";
import { Stack, Typography } from "@mui/material";

const Allergies = ({ allergies }) => {
  return (
    <Stack direction="column">
      <Typography variant="h5" fontWeight="bold">
        Allergies:
      </Typography>
      {allergies.length > 0 ? (
        <Typography variant="h6">{allergies.join(", ")}</Typography>
      ) : (
        <Typography variant="h6">No Known Drug Allergies.</Typography>
      )}
    </Stack>
  );
};

export default Allergies;
